




























































































import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class TabletMech extends Vue {
  /* TODO: Move data to service */
  private data() {
    return {
      tabletAssets: {
        sectionA: {
          elbowA: {
            url: require('../assets/home-mech/tablet/tablet-elbow-1_90x118.png'),
            alt: 'tablet elbow 1',
          },
          neckA: {
            url: require('../assets/home-mech/tablet/tablet-neck-1_28x138.png'),
            alt: 'tablet neck 2',
          },
          elbowB: {
            url: require('../assets/home-mech/tablet/tablet-elbow-2_52x68.png'),
            alt: 'tablet elbow 2',
          },
          neckB: {
            url: require('../assets/home-mech/tablet/tablet-neck-2_70x18.png'),
            alt: 'tablet neck 2',
          },
          neckC: {
            url: require('../assets/home-mech/tablet/tablet-neck-3_350x35.png'),
            alt: 'tablet neck 3',
          },
          neckD: {
            url: require('../assets/home-mech/tablet/tablet-neck-4_18x322.png'),
            alt: 'tablet neck 4',
          },
        },
        sectionB: {
          elbowA: {
            url: require('../assets/home-mech/tablet/tablet-elbow-3_70x74.png'),
            alt: 'tablet elbow 3',
          },
          neckA: {
            url: require('../assets/home-mech/tablet/tablet-neck-5_18x994.png'),
            alt: 'tablet neck 5',
          },
          elbowB: {
            url: require('../assets/home-mech/tablet/tablet-elbow-4_54x72.png'),
            alt: 'tablet elbow 4',
          },
          neckB: {
            url: require('../assets/home-mech/tablet/tablet-neck-6_160x18.png'),
            alt: 'tablet neck 6',
          },
          elbowC: {
            url: require('../assets/home-mech/tablet/tablet-elbow-5_68x54.png'),
            alt: 'tablet elbow 5',
          },
          neckC: {
            url: require('../assets/home-mech/tablet/tablet-neck-7_18x214.png'),
            alt: 'tablet neck 7',
          },
          valveA: {
            url: require('../assets/home-mech/mobile/mobile-valve-1_80x80.png'),
            alt: 'mobile valve 1',
          },
          neckD: {
            url: require('../assets/home-mech/tablet/tablet-neck-8_36x434.png'),
            alt: 'tablet neck 8',
          },
          neckE: {
            url: require('../assets/home-mech/tablet/tablet-neck-9_146x18.png'),
            alt: 'tablet neck 9',
          },
        },
        sectionC: {
          elbowA: {
            url: require('../assets/home-mech/tablet/tablet-elbow-6_68x52.png'),
            alt: 'tablet elbow 6',
          },
          neckA: {
            url: require('../assets/home-mech/tablet/tablet-neck-10_18x792.png'),
            alt: 'tablet neck 10',
          },
          elbowB: {
            url: require('../assets/home-mech/tablet/tablet-elbow-7_54x68.png'),
            alt: 'tablet elbow 7',
          },
          neckB: {
            url: require('../assets/home-mech/tablet/tablet-neck-11_290x18.png'),
            alt: 'tablet neck 11',
          },
          elbowC: {
            url: require('../assets/home-mech/tablet/tablet-elbow-8_70x64.png'),
            alt: 'tablet elbow 8',
          },
          neckC: {
            url: require('../assets/home-mech/tablet/tablet-neck-12_18x572.png'),
            alt: 'tablet neck 12',
          },
          valveA: {
            url: require('../assets/home-mech/mobile/mobile-valve-1_80x80.png'),
            alt: 'mobile valve 1',
          },
          neckD: {
            url: require('../assets/home-mech/tablet/tablet-neck-13_18x300.png'),
            alt: 'tablet neck 13',
          },
          neckE: {
            url: require('../assets/home-mech/tablet/tablet-neck-14_36x292.png'),
            alt: 'tablet neck 14',
          },
          neckF: {
            url: require('../assets/home-mech/tablet/tablet-neck-15_98x26.png'),
            alt: 'tablet neck 15',
          },
          elbowD: {
            url: require('../assets/home-mech/tablet/tablet-elbow-9_54x72.png'),
            alt: 'tablet elbow 9',
          },
          neckG: {
            url: require('../assets/home-mech/tablet/tablet-neck-16_74x24.png'),
            alt: 'tablet neck 16',
          },
        },
      },
    };
  }
}
